import React, { useState, useEffect } from 'react';
import UDIDropdownfield from "./UDIDropdownfield.js"

const BasicUDIDIIdentifier = ({
    UDI,
    setUDI,
    forceIsEditing = null
}) => {

	const fieldName = "BasicUDI_DI_Identifier";
	const fieldTitle = "Basic UDI-DI Identifier";
    const itemLink = "/your-medboard/product-portfolio/basic-udis/?basicudiId=";
    const [LOV, setLOV] = useState([]);


	useEffect(() => {

		let url = "/umbraco/api/RIMSProducts/BasicUDIs";

		let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

		fetch(url, requestOptions)
            .then((response) => {
                checkResponseError(response);
                return response.json();
            })
            .then((result) => {
				if (result) {

                    let converted = result.map(item => ({ key: item.Id, value: item.BasicUDI_DI_Code }));

                    converted = [ { key: "", value: "" }, ...converted];

					setLOV(converted);
				}
            })
            .catch((error) => {
            })
            .finally(() => {
            });

	}, []);

	
    const checkResponseError = (response) => {
        if (!response.ok) {
            if (response.status === 401)
                document.dispatchEvent(new Event("api:unauthorized"));
            throw new Error("Network response was not ok");
        }
    }

	return <>
        <UDIDropdownfield UDI={UDI} setUDI={setUDI} fieldTitle={fieldTitle} fieldName={fieldName} LOV={LOV} itemHasLink={itemLink} forceIsEditing={forceIsEditing} />
	</>											  
}


export default BasicUDIDIIdentifier;


